import {API_URL} from '../../config/constants';
import {UpdateModal} from '../../core-utilities/redux/update-modal';
import {getApiToken} from '../../auth/reducers';
import {modalOptions, UserProfile} from '../compoments/UserProfile';
import {getUpdateProfile} from '../reducers/state';
import {UPDATE_PROFILE_PREFIX} from './state';
import {logger} from './logger';

export const profileModal = new UpdateModal({
  prefix: UPDATE_PROFILE_PREFIX,
  getState: getUpdateProfile,
  showMessageTime: 0, // Remove if we add a success message
  requestUrl,
  getHeaders,
  requestOptions: {
    mode: 'cors',
  },
  requestMethod: 'PATCH',
  modalComponent: UserProfile,
  modalOptions,
  logger,
});

// HACK: Temporary
UserProfile.actions = profileModal.actions;

export const epics = profileModal.epics;

/** @callback {UpdateModalOptions~requestUrl} */
function requestUrl(action) {
  return `${API_URL}/api/users/${action.payload.data.id}`;
}

/** @callback {UpdateModalOptions~getHeaders} */
function getHeaders(action, rootState) {
  const token = getApiToken(rootState);
  return {
    'Authorization': `Bearer ${token}`,
    'Cache-Control': 'no-cache',
  };
}

// import {buildUpdateRequestModal} from '../../config/redux-list/requestModals';
// import {modalOptions, UserProfile} from '../compoments/UserProfile';
// import {getUpdateProfile} from '../reducers/state';
// import {logger} from './logger';
// import {UPDATE_PROFILE_PREFIX} from './state';
//
//
// export const {
//   requestModal: profileModal,
// } = buildUpdateRequestModal({
//   prefix: UPDATE_PROFILE_PREFIX,
//   getState: getUpdateProfile,
//   path: 'users',
//   modalOptions,
//   modalComponent: UserProfile,
//   logger,
// });
//
// // HACK: Temporary
// UserProfile.actions = profileModal.actions;



// WEBPACK FOOTER //
// ./src/js/user-profile/redux/profileModal.js